<script>
  import {mapGetters} from "vuex";

  export default {
    computed: {
      ...mapGetters(['permissions']),
    },
    methods: {
      hasPermMixin(codename) {
        return this.permissions.indexOf(codename) >= 0 ? true: false
      },
      isTeacher() {
        return this.permissions.find(perm => perm.indexOf("calibration") >= 0) ? true: false
      },
      getUserType() {
        if(this.isTeacher()) {
          return 1
        } else {
          return 0
        }
      }
    }
  }
</script>
